import React, {type ReactNode} from 'react';

type FileBrowserLayoutProps = {
  children: ReactNode;
  topLeft?: ReactNode;
  topRight?: ReactNode;
};

export function FileBrowserLayout({
  children,
  topLeft,
  topRight,
}: FileBrowserLayoutProps) {
  return (
    <div className="file-browser-page p-16 flex flex-col gap-16 min-h-full">
      <div className="flex flex-row items-center justify-between gap-16 h-32">
        <div className="grow shrink overflow-hidden">{topLeft}</div>
        {topRight}
      </div>
      {children}
    </div>
  );
}
